import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SolidInfo from './icon-solid-info.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SolidInfo {...validProps} />;
}
SvgComponent.iconName = 'solidInfo';

export const SolidInfoIcon = svgIconWrapper(SvgComponent);
